const MEDIA_ITEMS = [
  {
    title: '热门吃瓜直播回放',
    desc: '51cg吃瓜直播精彩片段合集，高清回放不容错过',
    tag: '直播',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20entertainment%20video%20thumbnail%20concept%20with%20abstract%20geometric%20shapes%20and%20soft%20coral%20amber%20gradient%20overlay%2C%20stylized%20play%20button%20icon%20in%20center%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20design%2C%20high%20detail%20digital%20illustration%2C%20cinematic%20feel&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '51吃瓜影视精选',
    desc: '本周必看的51吃瓜影视免费观看推荐片单',
    tag: '影视',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20amber%20golden%20toned%20movie%20themed%20abstract%20thumbnail%20with%20film%20strip%20motif%20and%20warm%20gradient%2C%20elegant%20minimalist%20design%20with%20subtle%20geometric%20patterns%2C%20cinematic%20lighting%20feel%2C%20clean%20composition%2C%20high%20detail%20digital%20art&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '吃瓜在线视频热榜',
    desc: '全网最火的吃瓜在线视频TOP10盘点',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20and%20peach%20toned%20trending%20content%20themed%20abstract%20thumbnail%20with%20flame%20and%20chart%20motifs%2C%20modern%20digital%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20design%2C%20energetic%20feel%2C%20high%20detail%20illustration&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    title: '51吃瓜高清专区',
    desc: '专为高清爱好者打造的51吃瓜视频在线专区',
    tag: '高清',
    image: 'https://readdy.ai/api/search-image?query=A%20crisp%20warm%20coral%20gradient%20abstract%20thumbnail%20with%20crystal%20clear%20diamond%20geometric%20motifs%2C%20premium%20streaming%20quality%20theme%2C%20clean%20luxurious%20minimalist%20design%2C%20soft%20glow%20effects%2C%20high%20detail%20digital%20art&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
];

const TOPICS = [
  { name: '今日热搜', heat: '999+', active: true },
  { name: '娱乐圈八卦', heat: '856', active: true },
  { name: '综艺节目', heat: '742', active: false },
  { name: '影视推荐', heat: '683', active: true },
  { name: '社会热点', heat: '621', active: false },
  { name: '明星动态', heat: '598', active: true },
  { name: '网红吃瓜', heat: '534', active: false },
  { name: '51cg直播', heat: '487', active: true },
  { name: '深夜话题', heat: '421', active: false },
  { name: '年度盘点', heat: '389', active: false },
];

export default function MediaTopicsSection() {
  return (
    <>
      {/* #media - 4 media cards */}
      <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              热门视频专区
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              精选51吃瓜视频在线热门内容，一网打尽精彩时刻
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {MEDIA_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-[10px] font-medium whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1 line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #topics - 10 topic tags */}
      <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              51吃瓜网在线观看当前最受关注的吃瓜话题标签
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {TOPICS.map((topic) => (
              <div
                key={topic.name}
                className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 whitespace-nowrap ${
                  topic.active
                    ? 'bg-primary-500 border-primary-500 text-white'
                    : 'bg-background-100 border-secondary-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                <span className="text-sm font-medium">{topic.name}</span>
                <span className={`text-xs font-semibold ${
                  topic.active ? 'text-white/80' : 'text-accent-600'
                }`}>
                  <i className="ri-fire-line mr-0.5 text-[10px]"></i>{topic.heat}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}